// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-app-menu-order[data-v-33541eea]{margin-block:12px}`, "",{"version":3,"sources":["webpack://./apps/theming/src/components/UserAppMenuSection.vue"],"names":[],"mappings":"AACA,sCACC,iBAAA","sourcesContent":["\n.user-app-menu-order {\n\tmargin-block: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
